module.exports = __webpack_public_path__ + "static/media/pre-arrival-in-stay-guest-book.f250ee54.png";